<template>
    <section class="bg-light" id="home">
        <div class="container-fluid container-lg">
            <div class="row justify-content-center align-items-center g-3 py-5">
                <div class="col-lg-6 order-1">
                    <div class="header-left">
                        <div class="header-text pb-2">
                            <h1 class="mb-3">The Best Solution <br class="d-none d-lg-block"> For Your Business.</h1>
                            <p>We convey your dreamed innovations with code.</p>
                        </div>

                        <div class="anchor-cta-link pt-3 pt-md-4">
                            <a class="call-to-action me-3 shadow-sm" target="_blank" href="https://api.whatsapp.com/send?phone=2348132961732&text=Hello%20Dacode%20%F0%9F%91%8B" >Let's Talk <span class="ms-1"><i class="fa fa-arrow-right"></i></span></a>
                            <a class="call-to-action-outline shadow-sm" href="/enroll" >Enroll <span class="ms-1"><i class="fa fa-user-plus"></i></span></a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 order-lg-1">
                    <div class="header-image">
                        <img class="img-fluid" src="../assets/dacodeheaderimage.svg"  alt="Dacode header image">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>
.header-text h1 {
    font-size: 3.5rem;
    color: var(--dacode-primary-color) !important;
}

.header-text p {
    letter-spacing: 2px;
}

.anchor-cta-link a {
    transition: 500ms;
    display: inline-block;
}

.anchor-cta-link a:hover {
    transform: translateY(-8%);
}

.anchor-cta-link .call-to-action {
    filter: drop-shadow(0px 11px 10px var(--dacode-primary-color));
}

.v-toast {
    font-size: .9rem;
}
</style>